<template>
    <BaseEditPage
        :context="context"
        :alvqa="alvqa"
        cancelIconRoute="/az/azlive"
    >
        <template v-slot:headline="{ data }">
            <div :alvqa="alvqa + '-venue-name'">
                {{ 
                    $route.params.alvId === 'new' ? 
                    $t('lang_GENERAL_CAPTION_EDIT_PAGE_UNTITLED') :  
                    data.name 
                }}
            </div>
        </template>

        <template v-slot:editForm="{ data }">
            <!-- Picture -->
            <v-col cols="1">
                <v-row>
                    <v-col v-if="data != null">
                        <v-img 
                            v-if="data.picture !== null"
                            :src="data.picture"
                        ></v-img>
                        <v-img
                            v-else
                            aspect-ratio="1"
                            class="defaultImageEditPage"
                            :alvqa="alvqa + '-image'"
                        >
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                                <!-- <BaseIcon 
                                    @click="uploadPicture()"
                                    icon="cloud_upload"
                                    tooltipText="lang_GENERAL_CAPTION_UPLOAD_IMAGE"
                                />   -->
                            </v-row>
                        </v-img>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-card elevation="0">
                            <v-card-text>
                                <div 
                                    class="read-only-caption"
                                    :alvqa="alvqa + '-caption-created'"
                                >{{ $t('lang_GENERIC_CAPTION_CREATED') }}:</div>
                                <div 
                                    v-if="data.created !== undefined"
                                    class="caption" 
                                    :alvqa="alvqa + '-created'"
                                >{{ data.created.name }}, {{ $d(new Date(data.created.date), 'alvDateTime',  $i18n.locale) }}</div>
                                <br />
                                <div 
                                    class="read-only-caption"
                                    :alvqa="alvqa + '-caption-last-updated'"
                                >{{ $t('lang_GENERIC_CAPTION_LAST_UPDATED') }}:</div>
                                <div 
                                    v-if="data.lastUpdated !== undefined"
                                    class="caption" 
                                    :alvqa="alvqa + '-last-updated'"
                                >{{ data.lastUpdated.name }}, {{ $d(new Date(data.lastUpdated.date), 'alvDateTime',  $i18n.locale) }}</div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col> 
            
            <v-col cols="3">
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="VenueName"
                        :label="$t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_VENUE')" 
                        rules="required"
                        :alvqa="alvqa + '-textfield-venue-name'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="AddressRow1"
                        :label="$t('lang_AZ_PERSONS_CAPTION_ADDRESS_ROW_1')"
                        rules="required"
                        :alvqa="alvqa + '-textfield-address-row-one'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="AddressRow2"
                        :label="$t('lang_AZ_PERSONS_CAPTION_ADDRESS_ROW_2')"
                        :alvqa="alvqa + '-textfield-address-row-two'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Zip"
                        :label="$t('lang_AZ_PERSONS_CAPTION_ZIP')"
                        rules="required"
                        :alvqa="alvqa + '-textfield-zip'"
                    />
                </v-row>
                 <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="City"
                        :label="$t('lang_AZ_PERSONS_CAPTION_CITY')"
                        rules="required"
                        :alvqa="alvqa + '-textfield-city'"
                    />
                </v-row>  
                 <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="State"
                        :label="$t('lang_AZ_PERSONS_CAPTION_STATE')"
                        :alvqa="alvqa + '-textfield-state'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Country"
                        :items="countries" 
                        :label="$t('lang_AZ_PERSONS_CAPTION_COUNTRY')"  
                        rules="required"
                        :alvqa="alvqa + '-dropdown-country'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextarea 
                        :context="context" 
                        field="ShippingAddress"
                        rows="5"
                        :label="$t('lang_AZ_GROUPS_CAPTION_SHIPPING_ADDRESS')" 
                        :alvqa="alvqa + '-textarea-shipping-address'"
                    />
                </v-row>
            </v-col>  

            <v-col cols="3">
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="AlvId"
                        :label="$t('lang_GENERIC_CAPTION_ALVID')"
                        :clearable="false"
                        :disabled="true"
                        :alvqa="alvqa + '-textfield-alvid'"
                    />
                </v-row>
                <v-row>
                    <!-- rules="url: {protocols: ['http','https'], require_protocol: true}" IS not in v3 of vee-validate, we need to update :) -->
                    <BaseEditPageTextField 
                        :context="context"
                        field="Web"
                        :label="$t('lang_AZ_PERSONS_CAPTION_WEB')"
                        :alvqa="alvqa + '-textfield-web'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Facebook"
                        :label="$t('lang_AZ_PERSONS_CAPTION_FACEBOOK')"
                        :alvqa="alvqa + '-textfield-facebook'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Twitter"
                        :label="$t('lang_AZ_PERSONS_CAPTION_TWITTER')"
                        :alvqa="alvqa + '-textfield-twitter'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Youtube"
                        :label="$t('lang_AZ_PERSONS_CAPTION_YOUTUBE')"
                        :alvqa="alvqa + '-textfield-youtube'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Tags"
                        :label="$t('lang_AZ_PERSONS_CAPTION_TAGS')"
                        :alvqa="alvqa + '-textfield-tags'"
                    />
                </v-row> 
                <v-row>
                    <!-- inv_lief_notice = Versandnotiz -->
                    <!-- inv_bemerkungen = Bemerkungen -->
                    <BaseEditPageTextarea 
                        :context="context"
                        field="ShippingNote"
                        rows="5"
                        :label="$t('lang_AZ_GROUPS_CAPTION_SHIPPING_NOTE')"
                        :alvqa="alvqa + '-textarea-shipping-note'"
                    />
                </v-row>
            </v-col>

            <v-col cols="3">
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Phone"
                        :label="$t('lang_AZ_PERSONS_CAPTION_PHONE')"
                        :alvqa="alvqa + '-textfield-phone'"
                    />
                </v-row>   
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Fax"
                        :label="$t('lang_AZ_PERSONS_CAPTION_FAX')"
                        :alvqa="alvqa + '-textfield-fax'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Cellphone"
                        :label="$t('lang_AZ_PERSONS_CAPTION_CELLPHONE')"
                        :alvqa="alvqa + '-textfield-cellphone'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Email"
                        :label="$t('lang_AZ_PERSONS_CAPTION_EMAIL')"
                        :alvqa="alvqa + '-textfield-email'"
                    />
                </v-row>  
                <v-row>
                    <BaseEditPageTextarea 
                        :context="context" 
                        field="Notes"
                        rows="7"
                        :label="$t('lang_GENERIC_CAPTION_NOTES')" 
                        :alvqa="alvqa + '-textarea-notes'"
                    />
                </v-row>
            </v-col> 

            <v-col cols="2">
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="KeyName"
                        :label="$t('lang_GENERIC_AZ_CAPTION_GEMA_NAME')"  
                        :clearable="false"
                        :readonly="true"
                        :alvqa="alvqa + '-textfield-key-name'"
                    />
                </v-row>     
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Visibility"
                        :items="visibilityItems" 
                        :label="$t('lang_AZ_PERSONS_CAPTION_VISIBILITY')"
                        :clearable="false"
                        :disabled="true"
                        :alvqa="alvqa + '-dropdown-visibility'" 
                    />
                </v-row>  
            </v-col>
        </template>

        <!-- Panels -->
        <!-- <template v-slot:panels>
            <AzLiveVenueRoomsEditPanel />
            <AzLiveVenueRoomsEditPanelDialog />
            <DeletionDialog context="SelectedAzLiveVenueRooms" />
        </template> -->
    </BaseEditPage>
</template>

<script>
import BaseEditPage from '@/components/_base/BaseEditPage'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageTextarea from '@/components/_editForm/BaseEditPageTextarea'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'

// import AzLiveVenueRoomsEditPanel from './_panels/AzLiveVenueRoomsEditPanel'
// import AzLiveVenueRoomsEditPanelDialog from './_panels/AzLiveVenueRoomsEditPanelDialog'
// import DeletionDialog from '@/components/_dialogs/DeletionDialog'

export default {
    name: "AzLiveEdit",
    components: {
        BaseEditPage,
        BaseEditPageTextField,
        BaseEditPageTextarea,
        BaseEditPageDropdown,
        // AzLiveVenueRoomsEditPanel,
        // AzLiveVenueRoomsEditPanelDialog,
        // DeletionDialog
    },
    data() {
        return {
            context: "AzLive",
            alvqa: "az-live-edit-form"
        }
    },
    computed: {
        visibilityItems() { 
            let visibilityArr
            let visibility = this.$store.getters['getVisibility' + this.$i18n.locale.toUpperCase()] 
            if(visibility === undefined) visibility = this.$store.getters.getVisibilityEN // fallback EN

            if(visibility !== undefined) {
                visibilityArr = JSON.parse(JSON.stringify(visibility))
                visibilityArr.forEach(element => {
                    element['alvqa'] = this.alvqa + '-dropdown-visibility-' + element.value
                });
            } else {
                visibilityArr = []
            }

            return visibilityArr
        },
        countries() { 
            return this.$alvPlugin.getListOfTranslatedCountries()
        },
    },
    mounted() {
        this.$store.commit('setVisibility')
        this.$store.commit('setCountries')
    }
}
</script>